import * as Yup from 'yup';

const FilterSchema = Yup.object().shape({
  customer_email: Yup.string().nullable().email('Campo não é um e-mail válido')
});

export default FilterSchema;
